// extracted by mini-css-extract-plugin
module.exports = {"circle":"Circle_circle__1ejgD","circleChild":"Circle_circleChild__X9SZX"};